import button, { buttonVariants, type ButtonVariantsType } from './button';
import carousel, { carouselVariants, type CarouselVariantsType } from './carousel';
import container, { containerVariants, type ContainerVariantsType } from './container';
import type { CustomTheme } from '../../../types/custom-theme';
import type { Product } from '../../../types/product';

const video = {
  button,
  carousel,
  container,
};

export const videoVariants = {
  button: buttonVariants,
  carousel: carouselVariants,
  container: containerVariants,
};

export type VideoComponentsType = 'button' | 'carousel' | 'container';

export interface VideoType {
  /** The Video subcomponent types. */
  SubComponents: {
    [K in VideoComponentsType]: Product.VariantKeyModes<
      K extends 'button'
        ? ButtonVariantsType
        : K extends 'carousel'
        ? CarouselVariantsType
        : K extends 'container'
        ? ContainerVariantsType
        : never
    >;
  };
  /** The Video Player Button component types. */
  Button: CustomTheme.VariantKeys<ButtonVariantsType>;
  /** The Video Carousel component types. */
  Carousel: CustomTheme.VariantKeys<CarouselVariantsType>;
  /** The Video Player Container component types. */
  Container: CustomTheme.VariantKeys<ContainerVariantsType>;
}

export default video;
